export default defineNuxtRouteMiddleware((to) => {
    // NOTE: When debug mode is enabled in .env useRuntimeConfig().app.debug is only set on the initial response from the server.
    // On the client side it's undefined after the initial response.
    // That's why browser back and links will not work when trying to navigate to a debug page.
    if (to.meta.isDebugPage && !useRuntimeConfig().app.debug)
        return abortNavigation();
});
